module.exports = __webpack_public_path__ + "img/3.0c28c9a8.svg";